import { useEffect } from 'react'

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot } from 'lexical'

export const ClearEmptyEditorPlugin = () => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const root = $getRoot()
        const children = root.getChildren()

        // If there's no text or only non-editable blocks (like tables), clear everything
        const isEffectivelyEmpty = children.every((node) => {
          return node.getTextContentSize() === 0
        })

        if (isEffectivelyEmpty && children.length > 0) {
          editor.update(() => {
            root.clear()
          })
        }
      })
    })
  }, [editor])

  return null
}
